/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppearanceStyle } from './AppearanceStyle';
import {
    AppearanceStyleFromJSON,
    AppearanceStyleFromJSONTyped,
    AppearanceStyleToJSON,
    AppearanceStyleToJSONTyped,
} from './AppearanceStyle';
import type { ColorPaletteId } from './ColorPaletteId';
import {
    ColorPaletteIdFromJSON,
    ColorPaletteIdFromJSONTyped,
    ColorPaletteIdToJSON,
    ColorPaletteIdToJSONTyped,
} from './ColorPaletteId';
import type { ThemeMode } from './ThemeMode';
import {
    ThemeModeFromJSON,
    ThemeModeFromJSONTyped,
    ThemeModeToJSON,
    ThemeModeToJSONTyped,
} from './ThemeMode';
import type { FontSize } from './FontSize';
import {
    FontSizeFromJSON,
    FontSizeFromJSONTyped,
    FontSizeToJSON,
    FontSizeToJSONTyped,
} from './FontSize';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTenantPersonalizationResponse
 */
export interface GetTenantPersonalizationResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTenantPersonalizationResponse
     */
    tenantId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ColorPaletteId}
     * @memberof GetTenantPersonalizationResponse
     */
    colorPaletteId: ColorPaletteId | null;
    /**
     * 
     * @type {AppearanceStyle}
     * @memberof GetTenantPersonalizationResponse
     */
    dashboardAppearance: AppearanceStyle | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantPersonalizationResponse
     */
    customColor: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantPersonalizationResponse
     */
    grainEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantPersonalizationResponse
     */
    gradientEnabled: boolean;
    /**
     * 
     * @type {FontSize}
     * @memberof GetTenantPersonalizationResponse
     */
    fontSize: FontSize;
    /**
     * 
     * @type {ThemeMode}
     * @memberof GetTenantPersonalizationResponse
     */
    themeModeControl: ThemeMode;
}



/**
 * Check if a given object implements the GetTenantPersonalizationResponse interface.
 */
export function instanceOfGetTenantPersonalizationResponse(value: object): value is GetTenantPersonalizationResponse {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('colorPaletteId' in value) || value['colorPaletteId'] === undefined) return false;
    if (!('dashboardAppearance' in value) || value['dashboardAppearance'] === undefined) return false;
    if (!('customColor' in value) || value['customColor'] === undefined) return false;
    if (!('grainEnabled' in value) || value['grainEnabled'] === undefined) return false;
    if (!('gradientEnabled' in value) || value['gradientEnabled'] === undefined) return false;
    if (!('fontSize' in value) || value['fontSize'] === undefined) return false;
    if (!('themeModeControl' in value) || value['themeModeControl'] === undefined) return false;
    return true;
}

export function GetTenantPersonalizationResponseFromJSON(json: any): GetTenantPersonalizationResponse {
    return GetTenantPersonalizationResponseFromJSONTyped(json, false);
}

export function GetTenantPersonalizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTenantPersonalizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'colorPaletteId': ColorPaletteIdFromJSON(json['colorPaletteId']),
        'dashboardAppearance': AppearanceStyleFromJSON(json['dashboardAppearance']),
        'customColor': json['customColor'],
        'grainEnabled': json['grainEnabled'],
        'gradientEnabled': json['gradientEnabled'],
        'fontSize': FontSizeFromJSON(json['fontSize']),
        'themeModeControl': ThemeModeFromJSON(json['themeModeControl']),
    };
}

export function GetTenantPersonalizationResponseToJSON(json: any): GetTenantPersonalizationResponse {
    return GetTenantPersonalizationResponseToJSONTyped(json, false);
}

export function GetTenantPersonalizationResponseToJSONTyped(value?: GetTenantPersonalizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'colorPaletteId': ColorPaletteIdToJSON(value['colorPaletteId']),
        'dashboardAppearance': AppearanceStyleToJSON(value['dashboardAppearance']),
        'customColor': value['customColor'],
        'grainEnabled': value['grainEnabled'],
        'gradientEnabled': value['gradientEnabled'],
        'fontSize': FontSizeToJSON(value['fontSize']),
        'themeModeControl': ThemeModeToJSON(value['themeModeControl']),
    };
}

